import React from "react"
import PropTypes from "prop-types"
import "../assets/css/components/solution-row.css"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
library.add(faCheckCircle, faExclamationCircle)

/**
 *  Vertically-oriented component for displaying Work Product solutions.
 *  Similar to SolutionBox component, but more simple.
 */
const SolutionRow = ({ type, percent, children }) => {
  return (
    <div className={`solution-row ${type}`}>
      <div className='top-border'>
        <div className='title'>
          <div className='title-contents'>
            {percent ? (
              `${percent}%`
            ) : (
              <FontAwesomeIcon icon={type === "correct" ? "check-circle" : "exclamation-circle"} />
            )}

            <br />
            <span>{type === "correct" ? "Correct Solution" : "Incorrect Solution"}</span>
          </div>
        </div>
      </div>
      <div className='children-container'>{children}</div>
    </div>
  )
}

SolutionRow.propTypes = {
  /** Either correct or incorrect. Determines the coloring of the component. */
  type: PropTypes.oneOf(["correct", "incorrect"]),
  percent: PropTypes.number,
  /** The contents of the solution to display, like flowcharts or categorization task categories */
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]).isRequired
}

export default SolutionRow
